import { Skeleton } from "@chakra-ui/react";
import React from "react";
export const Filterskeleton = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Skeleton, { height: "3rem", width: "100%" }),
        React.createElement(Skeleton, { height: "3rem", width: "100%" }),
        React.createElement(Skeleton, { height: "3rem", width: "100%" })));
};
